<div class="login-page">
  <aside class="login-brand">
    <div class="login-brand__head">
      <h1 class="login-brand__title">JioLoyalty</h1>
      <p class="login-brand__kicker">Partner and Business Portal</p>
    </div>

    <!-- Media: shimmer / cover image / fallback, centered in remaining space -->
    <div class="login-brand__media" aria-hidden="true">
      <div
        class="login-brand__shimmer"
        [class.login-brand__shimmer--hidden]="coverState !== 'loading'"
      ></div>
      <div
        class="login-brand__fallback"
        [class.login-brand__fallback--visible]="coverState === 'failed'"
      >
        <img
          src="assets/images/login/jio.svg"
          alt=""
          class="login-brand__fallback-logo"
        />
      </div>
      <div
        class="login-brand__cover"
        [class.login-brand__cover--visible]="coverState === 'loaded'"
        [style.backgroundImage]="coverBgStyle || null"
      ></div>
    </div>

    <div class="login-brand__foot">
      <h2 class="login-brand__foot-title">Sign in to your loyalty portal</h2>
      <p class="login-brand__foot-text">
        Authorized program administrators sign in with email and password or
        SAML via your organization's identity provider.
      </p>
    </div>
  </aside>

  <!-- Right: sign-in card -->
  <section class="login-panel">
    <div class="login-card">
      <img
        [src]="logoSrc"
        alt="Jio"
        class="login-card__logo"
        [class.login-card__logo--ready]="logoReady"
      />
      <hr class="login-card__logo-rule" />

      <h2 class="login-card__title">Sign in</h2>
      <p class="login-card__subtitle">
        Enter your email to continue with single sign-on.
      </p>

      <form
        (ngSubmit)="submit()"
        class="login-form"
        autocomplete="on"
        novalidate
      >
        <label class="login-form__label" for="login-email">Email ID</label>
        <input
          id="login-email"
          name="email"
          type="email"
          autocomplete="email"
          class="login-form__input"
          [class.login-form__input--error]="emailError"
          placeholder="Enter Email ID"
          [(ngModel)]="email"
          [disabled]="isSubmitting"
          (blur)="onEmailBlur()"
          (input)="onEmailInput()"
        />
        @if (emailError) {
        <p class="login-form__field-error">{{ emailError }}</p>
        } @if (errorMessage) {
        <p class="login-form__error">{{ errorMessage }}</p>
        }

        <button
          type="submit"
          class="login-form__submit"
          [disabled]="isSubmitting || !canSubmit"
        >
          {{ submitLabel }}
        </button>
      </form>

      <footer class="login-footer">
        <span>Powered by</span>
        <img
          src="assets/images/sidenav/jioloyalty_logo_black.svg"
          alt="JioLoyalty"
          class="login-footer__logo"
        />
      </footer>
    </div>
  </section>
</div>
